'use client';
import { milliseconds } from 'date-fns';

const SECOND = milliseconds({ seconds: 1 });
const MINUTE = milliseconds({ minutes: 1 });
const HOUR = milliseconds({ hours: 1 });
const DAY = milliseconds({ days: 1 });
const WEEK = milliseconds({ weeks: 1 });
const MONTH = milliseconds({ months: 1 });
const YEAR = milliseconds({ years: 1 });

export { DAY, HOUR, MINUTE, MONTH, SECOND, WEEK, YEAR };
//# sourceMappingURL=constants.js.map
